// A user's round picture: the image the user gave (a file of the chat), or the initials of the user's
// name on a colour of the user's own, the same every time.
import { avatarOf, fileUrl, nameOf } from "../store.ts";

/** The picture of user `id`: `size` px, or as the tiles say (`--avatar`). */
export function Avatar({ id, size }: { id: number; size?: number }) {
  const sized = size === undefined ? "" : `--avatar:${size}px`;
  const pic = avatarOf(id);
  if (pic !== "")
    return <img class="avatar" src={fileUrl(pic)} alt="" style={sized} loading="lazy" draggable={false} />;
  return (
    <span class="avatar" style={`background:${colour(id)};${sized}`} aria-hidden="true">
      {initials(nameOf(id))}
    </span>
  );
}

/** The colours of avatars: the brand's navy and steel blue, and quiet colours beside them, each dark
 * enough for white initials. */
const COLOURS = ["#17252e", "#5485a7", "#0f8a80", "#7b62b0", "#c0654b", "#a3812e", "#3f6fbf", "#9a4f7c"];

/** A colour of the avatar of `id`, the same every time. */
export function colour(id: number): string {
  return COLOURS[id % COLOURS.length];
}

function initials(name: string): string {
  const parts = name
    .trim()
    .split(/\s+/)
    .filter((p) => p !== "");
  return (
    parts
      .slice(0, 2)
      .map((p) => [...p][0].toUpperCase())
      .join("") || "?"
  );
}
